import './BookExtractsSearch.scss'

interface BookExtractsSearchProps {
  value: string;
  onChange: (value: string) => void;
}

function BookExtractsSearch({ value, onChange }: BookExtractsSearchProps) {
  return (
    <form className="book-search" role="search" onSubmit={(event) => event.preventDefault()}>
      <input
        type="search"
        className="book-search__input"
        name="query"
        aria-label="Search books"
        placeholder="Search by title, author"
        autoComplete="off"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </form>
  );
}

export default BookExtractsSearch;
